import _ from 'lodash';
import { Optional } from '@mews/std';
import { isNil } from './func';

interface EventMap {
    [type: string]: EventListenerOrEventListenerObject;
}

export function getMousePosition(event: MouseEvent) {
    return {
        x: event.pageX - (window.scrollX || window.pageXOffset),
        y: event.pageY - (window.scrollY || window.pageYOffset),
    };
}

export function getTouchPosition(event: TouchEvent) {
    return {
        x: event.touches[0].pageX - (window.scrollX || window.pageXOffset),
        y: event.touches[0].pageY - (window.scrollY || window.pageYOffset),
    };
}

export function addEventsToDocument(eventMap: EventMap) {
    _.each(eventMap, (handler, type) => document.addEventListener(type, handler, false));
}

export function removeEventsFromDocument(eventMap: EventMap) {
    _.each(eventMap, (handler, type) => document.removeEventListener(type, handler, false));
}

export function isTargetDescendant(event: Event, parent?: HTMLElement | null) {
    return !isNil(parent) && !isNil(event.target) && isDescendant(event.target as HTMLElement, parent);
}

export function isDescendant(element: Element, parent: Element) {
    let node = element as Optional<Node>;
    while (!isNil(node)) {
        if (node === parent) {
            return true;
        }
        node = node.parentNode;
    }

    return false;
}

export function pauseEvent(event: Event) {
    event.stopPropagation();
    event.preventDefault();
}
